import React from "react";
import { Col } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { isMobile } from "react-device-detect";
function SkeletonAmusementGroup() {
  return (
    <Col xs="auto" className="text-center">
      {isMobile ? (
        <Skeleton
          height={90}
          width={90}
          style={{ borderRadius: "26px" }}
        ></Skeleton>
      ) : (
        <Skeleton
          height={100}
          width={100}
          style={{ borderRadius: "25px" }}
        ></Skeleton>
      )}

      <span className="mb-4 mt-3 text-truncate-1-line">
        <Skeleton height={10} width="60%"></Skeleton>
      </span>
    </Col>
  );
}
export default SkeletonAmusementGroup;
